import { toast } from 'sonner';
import { api } from '../../lib/api';

/**
 * Descarga un archivo de Drive tal cual o convertido por el motor (PDF, Word, ODF, CSV…).
 * Con `link` vale también para quien entró por el enlace público sin cuenta. Los formatos que
 * existen para cada archivo los da el backend (`descargas` de /office/config): no se inventan aquí.
 */
function nombreDe(cabecera, respaldo) {
  const utf8 = /filename\*=UTF-8''([^;]+)/i.exec(cabecera || '');
  if (utf8) {
    try {
      return decodeURIComponent(utf8[1]);
    } catch {
      /* nombre mal codificado: se usa el otro */
    }
  }
  const simple = /filename="([^"]+)"/i.exec(cabecera || '');
  return simple ? simple[1] : respaldo;
}

async function mensajeDeError(err) {
  const data = err?.response?.data;
  if (data instanceof Blob) {
    try {
      const json = JSON.parse(await data.text());
      if (typeof json.detail === 'string') return json.detail;
    } catch {
      /* no era JSON */
    }
  }
  return 'No se pudo descargar';
}

export async function descargarArchivo({ fileId, formato = 'original', link, nombre }) {
  const convierte = formato !== 'original';
  const aviso = convierte ? toast.loading(`Preparando .${formato}…`) : null;
  try {
    const res = await api.get(`/office/descargar/${fileId}`, {
      params: { formato, ...(link ? { link } : {}) },
      responseType: 'blob',
      timeout: 180000, // un PDF grande a Word tarda
    });
    const url = URL.createObjectURL(res.data);
    const a = document.createElement('a');
    a.href = url;
    a.download = nombreDe(res.headers?.['content-disposition'], nombre || 'archivo');
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(() => URL.revokeObjectURL(url), 30000);
    if (aviso) toast.success('Descarga lista', { id: aviso });
  } catch (err) {
    const texto = await mensajeDeError(err);
    if (aviso) toast.error(texto, { id: aviso });
    else toast.error(texto);
  }
}
